import { render } from "./sliderArea.vue?vue&type=template&id=9ce2d1f6"
import script from "./sliderArea.vue?vue&type=script&lang=js"
export * from "./sliderArea.vue?vue&type=script&lang=js"
script.render = render

export default script